import { Components } from '@ionic/core/dist/types/components';
import { IonContent, IonPopover } from '@ionic/react';
import React, { ReactElement, useMemo } from 'react';
import { v4 as uuid } from 'uuid';

interface TooltipProps {
  triggerElement: ReactElement;
  text: string;
  popoverProps?: Partial<Components.IonPopover>;
}

const Tooltip = (props: TooltipProps) => {
  const { triggerElement, text, popoverProps } = props;
  const id = uuid();
  const triggerId = `tooltip-trigger-${id}`;
  const mergedProps: Partial<Components.IonPopover> = useMemo(() => {
    return {
      side: 'top',
      arrow: true,
      // having this prop set ensures the popover always appears on the same side
      keepContentsMounted: true,
      ...popoverProps,
      showBackdrop: false,
      trigger: triggerId,
    };
  }, [popoverProps, triggerId]);

  return (
    <>
      {React.cloneElement(triggerElement, { id: triggerId })}
      <IonPopover {...mergedProps}>
        <IonContent className="ion-padding" scrollY={false}>
          {text}
        </IonContent>
      </IonPopover>
    </>
  );
};

export { Tooltip };
